export default function stopPropagation(e: React.MouseEvent): void {
  e.stopPropagation();
}
